import { Component, signal } from '@angular/core';
import { SharedModule } from '../../../../../../shared/shared.module';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { RouterModule } from '@angular/router';
import { menuItems } from '../../utils/menu';
import { PAGE_ROUTES } from '@apps/landing/src/app/shared/constants/routes.enum';

@Component({
  selector: 'app-header-navigation-mobile',
  imports: [SharedModule, HlmButtonDirective, RouterModule],
  standalone: true,
  templateUrl: './header-navigation-mobile.component.html',
})
export class HeaderNavigationMobileComponent {
  protected readonly menuOpened = signal<boolean>(false);
  protected readonly employeePortalUrl = signal<string>('https://portal.sapec.md');

  protected readonly menuItems = menuItems;
  protected readonly PAGE_ROUTES = PAGE_ROUTES;

  private readonly preventTouchMove = (e: TouchEvent) => {
    e.preventDefault();
  };

  protected toggleMenu(state?: boolean) {
    if (this.menuOpened() === state) {
      return;
    }

    this.menuOpened.set(state || !this.menuOpened());

    if (this.menuOpened()) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', this.preventTouchMove, { passive: false });
    } else {
      document.body.style.overflow = 'auto ';
      document.removeEventListener('touchmove', this.preventTouchMove);
    }
  }
}
